import * as z from 'zod';

export const registrarManagementQuerySchema = z.enum(['internal', 'external']);

type RegistrarManagementQuerySchema = z.infer<typeof registrarManagementQuerySchema>;
export type RegistrarManagementMutationSchema = RegistrarManagementQuerySchema;

export const registrarManagementFormSchema = z.object({
  name: z.string(),
  value: registrarManagementQuerySchema,
});

type RegistrarManagementFormSchema = z.infer<typeof registrarManagementFormSchema>;

export const defaultRegistrarManagement = null;

export const registrarManagementOptions: RegistrarManagementFormSchema[] = [
  { name: 'Internal', value: 'internal' },
  { name: 'External', value: 'external' },
];

export function strToRegistrarManagement(
  registrarManagement: RegistrarManagementQuerySchema | null
): RegistrarManagementFormSchema | null {
  return registrarManagementOptions.find((option) => option.value === registrarManagement) ?? null;
}

export function registrarManagementToStr(
  registrarManagement?: RegistrarManagementFormSchema | null
): RegistrarManagementQuerySchema | null {
  return registrarManagement?.value ?? null;
}
